import React from 'react';

import styled from 'styled-components';

import { ILocaleImageFragment, ILocaleStringFragment } from 'generated/sanity-graphql';
import {
  CellDescription,
  CellDetails,
  CellTitle,
  StyledPicture,
  Tile,
} from 'pages/loyalty/loyalty-in-restaurant-redemption-signup-v3/styled';
import { primitive } from 'styles/constants/primitives';

const Container = styled.div`
  width: 100%;
  padding: 1.2rem;
  background: ${primitive.$white};
  border-radius: 1rem;
  margin: 1rem 1.5rem;
  outline: ${p => p.theme.cardOutline};

  ${Styles.desktop} {
    width: 45%;
    max-width: 44rem;
    margin: 0 1rem;
  }
`;

const BlockDetails = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
`;

const BlockIcon = styled(StyledPicture)`
  max-width: 3.5rem;
`;

const BlockTitle = styled(CellTitle)`
  font-size: 1.2rem;
`;

const InfoDetails = styled(CellDetails)`
  margin: 0.5rem 0;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-content: space-evenly;
`;

const InfoTile = styled(Tile)`
  margin-block-start: 1rem;
  margin-block-end: 0;
  margin-inline: 0;
  border-radius: 1rem;
`;

const InfoCellTitle = styled(CellTitle)`
  width: 100%;
`;

const InfoStyledPicture = styled(StyledPicture)`
  max-width: 5rem;

  ${Styles.desktop} {
    max-width: 6rem;
  }
`;

export type IInfoCellsWidgetProps = {
  title?: ILocaleStringFragment;
  icon?: ILocaleImageFragment;
  infoCells?: any;
};

export const InfoCellsWidget: React.FC<IInfoCellsWidgetProps> = ({ title, icon, infoCells }) => {
  return (
    <Container>
      <BlockDetails>
        <BlockIcon image={icon?.locale} alt="" objectFitContain />
        <BlockTitle>{title?.locale}</BlockTitle>
      </BlockDetails>
      {infoCells?.map((tile: any, id: any) => (
        <InfoTile key={id}>
          <InfoStyledPicture
            image={tile?.loyaltyTiersSignupCellImage?.locale}
            alt=""
            objectFitContain
          />
          <InfoDetails>
            <InfoCellTitle>{tile?.loyaltyTiersSignupCellTitle?.locale}</InfoCellTitle>
            <CellDescription>{tile?.loyaltyTiersSignupCellDescription?.locale}</CellDescription>
          </InfoDetails>
        </InfoTile>
      ))}
    </Container>
  );
};
